// extracted by mini-css-extract-plugin
module.exports = {"truncatedTd":"DeviceListTableRow_truncatedTd__3s5mc","tableRow":"DeviceListTableRow_tableRow__3NpTZ","tableRowSuspended":"DeviceListTableRow_tableRowSuspended__3LF_K"};